import React from "react";
import {
  SmileTwoTone,
  HeartTwoTone,
  CheckCircleTwoTone,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { Form, Row, Col, Button } from "antd";
import UnifiedInput from "../../components/ReportFormGenerator/UnifiedInput/UnifiedInput";
import HModal from "../HModal";
import liracrypt from "../../components/Liracrypt/liracrypt";

function QualityApproval({
  stat,
  completed,
  disabled,
  QualityName,
  QualityId,
  remark,
  _id,
  setState,
}) {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [modalLoading, setModalLoading] = React.useState(false);

  const [form] = Form.useForm();

  const EditClick = () => {
    setModalLoading(true);
    setModalVisible(true);
    liracrypt


      .get("/smodal", {
        dictName: "FourM_BSL_QA_Approval",
        auxFunc: {
          auxFuncName: "update_default_values",
          auxFuncParams: { auxSubFuncName: "BslQaApproval", fourMid: _id }
        }
      })







      .then((res, req) => {

        setData(res["data"]["config"]);
        setModalLoading(false);
        // setData(res.data.data);
      })
      .catch((err) => { });
  };

  const onFinish = (value) => {

  };
  return (
    <>
      <HModal
        isModalVisible={modalVisible}
        setIsModalVisible={setModalVisible}
        modalLoading={modalLoading}
        modalMethod={"edit"}
        action={{ edit: data }}
        modalData={null}
        extraData={{ _id: _id, typ: "app_Qa" }}
        mergeData={true}
        setState={setState}
      />
      <div
        style={{
          margin: "10px",
          padding: "20px",
          backgroundColor: "#3b3b3b",
          minHeight: "200px",
          borderRadius: "10px",
          boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
          border: completed ? "2px solid #52c41a" : "",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              fontSize: "20px",
              fontWeight: 600,
              display: "flex",
              flex: 1,
              color: "lightgrey",
            }}
          >
            QUALITY APPROVAL
          </div>
          <div style={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
            {completed ? (
              <CheckCircleTwoTone
                twoToneColor={completed ? "#52c41a" : "lightgrey"}
                style={{ fontSize: "30px" }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="AuditSection CreateAudit">
          <div className="ThemeForm">
            <Form
              name="ReportForm"
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              layout="horizontal"
              colon={false}
              onFinish={onFinish}
              size="large"
            >
              <Row gutter={24} justify="center" style={{ marginTop: "20px" }}>
                <Col span={12}>
                  <UnifiedInput
                    form={form}
                    colSpan={24}
                    disabled={disabled ? disabled : false}
                    typ={"textBox"}
                    name={"Qa"}
                    // placeHolder={"Remarks"}
                    label={"QA InCharge"}
                    errorMessage={`Please Select Production InCharge !`}
                    required={false}
                    defaultValue={QualityName}
                  />
                  <Col span={24}>
                    <div
                      style={{
                        display: "flex",
                        margin: "10px",
                        marginTop: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          color: "lightgrey",
                          justifyContent: "start",
                          alignItems: "center",
                          fontWeight: 600,
                        }}
                      >
                        STATUS :
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor:
                              stat === "X"
                                ? "#dc3545"
                                : stat === "C"
                                  ? "#008000"
                                  : stat === "H"
                                    ? "#ff6600"
                                    : stat === "I"
                                      ? "#fce205"
                                      : stat === "O"
                                        ? "#007bff"
                                        : "",
                            color: "#fff",
                            padding: "10px",
                            width: "100%",
                            borderRadius: "10px",
                            fontWeight: 600,
                            textAlign: "center",
                          }}
                        >
                          {stat === "C"
                            ? "APPROVED"
                            : stat === "O"
                              ? "NOt APPROVED"
                              : stat === "X"
                                ? "CANCEL"
                                : stat === "H"
                                  ? "HOLD"
                                  : ""}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Col>
                <Col span={12}>
                  <UnifiedInput
                    form={form}
                    colSpan={24}
                    disabled={disabled ? disabled : false}
                    typ={"textArea"}
                    name={"rmrk"}
                    placeHolder={"Remarks"}
                    label="Remarks"
                    errorMessage={"Please Select Remarks !"}
                    required={true}
                    defaultValue={remark}
                  />
                  <Col span={24}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "10px",
                      }}
                    >
                      <Button
                        disabled={!disabled}
                        type="primary"
                        style={{
                          fontWeight: 600,
                          borderRadius: "10px",

                          // marginBottom: 0,
                        }}
                        loading={modalVisible}
                        onClick={EditClick}
                      >
                        APPROVE
                      </Button>
                    </div>
                  </Col>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default QualityApproval;
